"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.describePassengersBatch = exports.getPassengerBatches = exports.diffPassengerSelect = exports.isCrRefused = exports.isCrStatusRefused = exports.refusedChangeRequestStatuses = exports.isCrAccepted = exports.isCrStatusAccepted = exports.acceptedChangeRequestStatuses = void 0;
exports.isSameDatetime = isSameDatetime;
exports.isSimilarDatetime = isSimilarDatetime;
exports.getDiffs = getDiffs;
exports.getMergedDiffs = getMergedDiffs;
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("@ambler/moment"));
var utils_1 = require("../utils");
var formatter_1 = require("../formatter");
var passenger_1 = require("./passenger");
// --- ACCEPTED ---
exports.acceptedChangeRequestStatuses = [
    'ACCEPTED',
    'TC_ACCEPTED',
    'HPTL_ACCEPTED',
    'TPTR_ACCEPTED',
    'AUTO_ACCEPTED',
];
var isCrStatusAccepted = function (status) {
    var acceptedChangeRequestStatuses_ = exports.acceptedChangeRequestStatuses;
    return acceptedChangeRequestStatuses_.includes(status);
};
exports.isCrStatusAccepted = isCrStatusAccepted;
var isCrAccepted = function (cr) { return (0, exports.isCrStatusAccepted)(cr.status); };
exports.isCrAccepted = isCrAccepted;
// --- REFUSED ---
exports.refusedChangeRequestStatuses = ['TC_REFUSED', 'HPTL_REFUSED', 'TPTR_REFUSED'];
var isCrStatusRefused = function (status) {
    var refusedChangeRequestStatuses_ = exports.refusedChangeRequestStatuses;
    return refusedChangeRequestStatuses_.includes(status);
};
exports.isCrStatusRefused = isCrStatusRefused;
var isCrRefused = function (cr) { return (0, exports.isCrStatusRefused)(cr.status); };
exports.isCrRefused = isCrRefused;
exports.diffPassengerSelect = {
    id: true,
    status: true,
    direction: true,
    isAccompanied: true,
    requestedVehicle: true,
    transportReason: true,
    reason: true,
    specificNeeds: true,
    patientCondition: true,
    originServiceRaw: true,
    destinationServiceRaw: true,
    departureTime: true,
    arrivalTime: true,
    timeReference: true,
    patient: {
        select: {
            id: true,
        },
    },
    origin: {
        select: {
            id: true,
        },
    },
    originMfd: {
        select: {
            id: true,
        },
    },
    destination: {
        select: {
            id: true,
        },
    },
    destinationMfd: {
        select: {
            id: true,
        },
    },
    otherPassenger: {
        select: {
            id: true,
            status: true,
            departureTime: true,
            arrivalTime: true,
            timeReference: true,
        },
    },
    shouldMtWait: true,
    details: true,
    preferredMt: {
        select: {
            id: true,
        },
    },
    trip: {
        select: {
            passengers: {
                select: { id: true, status: true },
            },
        },
    },
};
var getOriginMfd = function (passenger) {
    var _a, _b;
    return (_b = (_a = passenger === null || passenger === void 0 ? void 0 : passenger.originMfd) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : passenger === null || passenger === void 0 ? void 0 : passenger.originServiceRaw;
};
function isSameDatetime(passengerA, passengerB) {
    if (!passengerA || !passengerB) {
        return true;
    }
    if (passengerA.timeReference !== passengerB.timeReference) {
        return false;
    }
    var dateTimeA = passengerA.timeReference === 'ARRIVAL' ? passengerA.arrivalTime : passengerA.departureTime;
    var dateTimeB = passengerB.timeReference === 'ARRIVAL' ? passengerB.arrivalTime : passengerB.departureTime;
    return (0, moment_1.default)(dateTimeA).startOf('minute').isSame((0, moment_1.default)(dateTimeB).startOf('minute'));
}
function isSimilarDatetime(passengerA, passengerB) {
    if (passengerA.timeReference !== passengerB.timeReference) {
        return false;
    }
    var dateTimeA = passengerA.timeReference === 'ARRIVAL' ? passengerA.arrivalTime : passengerA.departureTime;
    var dateTimeB = passengerB.timeReference === 'ARRIVAL' ? passengerB.arrivalTime : passengerB.departureTime;
    return Math.abs((0, moment_1.default)(dateTimeA).diff(dateTimeB, 'minutes')) <= 30;
}
var getDestinationMfd = function (passenger) {
    var _a, _b;
    return (_b = (_a = passenger.destinationMfd) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : passenger.destinationServiceRaw;
};
function getDiffs(_a) {
    var _b, _c;
    var id = _a.id, changedPassenger = _a.passenger, requestedPassenger = _a.requestedPassenger;
    var diffs = {
        hasPatientChanged: false,
        hasAccompaniedChanged: false,
        hasRequestedVehicleChanged: false,
        hasTransportReasonChanged: false,
        hasSpecificNeedsChanged: false,
        hasPatientConditionChanged: false,
        hasOriginChanged: false,
        hasDestinationChanged: false,
        hasOriginMfdChanged: false,
        hasDestinationMfdChanged: false,
        hasOutboundChanged: false,
        hasInboundBeenAdded: false,
        hasInboundBeenRemoved: false,
        hasInboundChanged: false,
        hasShouldMtWaitChanged: false,
        hasCommentChanged: false,
    };
    if (!requestedPassenger) {
        diffs.hasInboundBeenRemoved = true;
        return diffs;
    }
    if (!changedPassenger) {
        diffs.hasInboundBeenAdded = true;
        return diffs;
    }
    diffs.hasPatientChanged = changedPassenger.patient.id !== requestedPassenger.patient.id;
    diffs.hasAccompaniedChanged = changedPassenger.isAccompanied !== requestedPassenger.isAccompanied;
    diffs.hasRequestedVehicleChanged = changedPassenger.requestedVehicle !== requestedPassenger.requestedVehicle;
    diffs.hasTransportReasonChanged = changedPassenger.transportReason !== requestedPassenger.transportReason;
    diffs.hasSpecificNeedsChanged = !(0, lodash_1.isEqual)(requestedPassenger.specificNeeds, changedPassenger.specificNeeds);
    diffs.hasPatientConditionChanged = !(0, lodash_1.isEqual)(requestedPassenger.patientCondition, changedPassenger.patientCondition);
    diffs.hasOriginChanged = changedPassenger.origin.id !== requestedPassenger.origin.id;
    diffs.hasDestinationChanged = changedPassenger.destination.id !== requestedPassenger.destination.id;
    diffs.hasOriginMfdChanged = getOriginMfd(changedPassenger) !== getOriginMfd(requestedPassenger);
    diffs.hasDestinationMfdChanged = getDestinationMfd(changedPassenger) !== getDestinationMfd(requestedPassenger);
    diffs.hasOutboundChanged =
        changedPassenger.direction === 'OUTBOUND' && !isSameDatetime(changedPassenger, requestedPassenger);
    diffs.hasInboundBeenAdded = !changedPassenger && requestedPassenger.direction === 'INBOUND';
    diffs.hasInboundChanged =
        changedPassenger.direction === 'INBOUND' && !isSameDatetime(changedPassenger, requestedPassenger);
    diffs.hasShouldMtWaitChanged = changedPassenger.shouldMtWait !== requestedPassenger.shouldMtWait;
    diffs.hasCommentChanged = ((_b = changedPassenger.details) !== null && _b !== void 0 ? _b : '') !== ((_c = requestedPassenger.details) !== null && _c !== void 0 ? _c : '');
    if (!id) {
        return diffs;
    }
    var result = {};
    for (var _i = 0, _d = (0, utils_1.getKeys)(diffs); _i < _d.length; _i++) {
        var key = _d[_i];
        result[key] = diffs[key] ? id : false;
    }
    return result;
}
function getMergedDiffs(changes) {
    var diffs = changes.map(function (change) { return getDiffs(change); });
    var mergedDiffs = {};
    var _loop_1 = function (key) {
        var firstDiff = diffs.find(function (diff) { return diff[key]; });
        if (firstDiff) {
            mergedDiffs[key] = firstDiff[key];
        }
    };
    for (var _i = 0, _a = (0, utils_1.getKeys)(diffs[0]); _i < _a.length; _i++) {
        var key = _a[_i];
        _loop_1(key);
    }
    return mergedDiffs;
}
// Get IDs of passengers with breaking changes & all those impacted by them
var getBrokenPassengersIds = function (changes) {
    return changes
        .filter(function (c) { return c.willBreakPooling; })
        .flatMap(function (_a) {
        var _b;
        var requestedPassenger = _a.requestedPassenger, passenger = _a.passenger;
        return __spreadArray([
            requestedPassenger === null || requestedPassenger === void 0 ? void 0 : requestedPassenger.id
        ], ((_b = passenger === null || passenger === void 0 ? void 0 : passenger.trip.passengers.map(function (_a) {
            var id = _a.id;
            return id;
        })) !== null && _b !== void 0 ? _b : []), true);
    })
        .filter(Boolean);
};
var getPassengerBatches = function (changes) {
    var requestedPassengers = changes.flatMap(function (c) { return c.requestedPassenger; });
    // The `unchangedPassengers` are the copassengers of the CHANGED passenger
    var unchangedPassengers = changes
        .flatMap(function (c) { var _a; return (_a = c.passenger) === null || _a === void 0 ? void 0 : _a.trip.passengers.filter(function (p) { var _a; return p.id !== ((_a = c.passenger) === null || _a === void 0 ? void 0 : _a.id); }); })
        .filter(Boolean)
        .filter(function (p) { return !passenger_1.canceledAbortedPassengerStatuses.includes(p.status); });
    // The `futurePassengers` are the passengers that will be shown on the CR page
    var futurePassengers = __spreadArray(__spreadArray([], requestedPassengers, true), unchangedPassengers, true).filter(Boolean);
    if (changes.every(function (c) { return !c.willBreakPooling; })) {
        // When there is no pooling being broken, we show all passengers together in one batch
        return [futurePassengers];
    }
    if (changes.every(function (c) { return c.willBreakPooling; })) {
        // When the outbound and inbound are broken, we split the page by patient
        return Object.values((0, lodash_1.groupBy)(futurePassengers, function (p) { return p.patient.id; }));
    }
    var brokenPassengersIds = getBrokenPassengersIds(changes);
    var _a = (0, lodash_1.partition)(futurePassengers, function (p) { return brokenPassengersIds.includes(p.id); }), brokenPassengers = _a[0], intactPassengers = _a[1];
    // When there is one breaking change and one non-breaking change
    return __spreadArray(__spreadArray([], brokenPassengers.map(function (p) { return [p]; }), true), [
        // and group the others in one batch
        intactPassengers,
    ], false).filter(function (b) { return b.length > 0; })
        .sort(function (a, b) { return new Date(a[0].departureTime).getTime() - new Date(b[0].departureTime).getTime(); });
};
exports.getPassengerBatches = getPassengerBatches;
var describePassengersBatch = function (passengers) {
    return (0, lodash_1.capitalize)((0, lodash_1.uniq)(passengers.filter(Boolean).map(function (_a) {
        var direction = _a.direction;
        return (0, formatter_1.formatDirection)(direction);
    })).join('-'));
};
exports.describePassengersBatch = describePassengersBatch;
//# sourceMappingURL=change-request.js.map